export const BOOTCAMP_PAGE_EXPERIMENT = {
  name: 'ai_trading_bootcamp_page_redesign_2026_08',
  featureFlag: 'ai-trading-bootcamp-page-redesign-2026-08',
  posthogExperimentId: 445277,
  variants: {
    control: 'Current bootcamp page',
    test: 'Refined bootcamp page',
  },
  primaryMetric: 'Live Bootcamp checkout starts per exposed user',
  secondaryMetrics: [
    'Live Bootcamp PaymentReceived per exposed user',
    'Live Bootcamp revenue per exposed user',
  ],
} as const;
